import { Component, OnInit, Input, ElementRef, ViewChild, Output, EventEmitter } from '@angular/core';


import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';

import {FormControl} from '@angular/forms';

import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material/autocomplete';

 
@Component({
  selector: 'app-formulemaker',
  templateUrl: './formulemaker.component.html',
  styleUrls: ['./formulemaker.component.css']
})

export class FormulemakerComponent implements OnInit {
 
  checkboxEditDeactivate: any ;
  checkStatus: any ;
  ParamsName: any;

  choicebiIns: any ;


  addOnBlur = false;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  setOfElts: string[] = [];
  selectable = true;
  removable = true;

  choosenType = "" ;
  choicebi = "" ;


  formulation = [] ;

  valToAdd = "" ;

  allformulas =[] ;

  @Output() FormulaToReturnBackEvent = new EventEmitter<string>();


  predefini : any ;

  predefinedSetOfElts : any ;

  removablePredef = true;

  fruitCtrl = new FormControl();

  @ViewChild('fruitInput') fruitInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  input:string = "";
  result:string = "";
  
  allParams = ["Responsabilité Civile", "Dommage ou Tierce", "Incendie", "Vol", "Bris de Glace", 
                "Sécurité Routière", "Puissance", "Nombre de places", "Energie", "Charge du véhicule",
                "Valeur Venale", "Taux de Prime dommage",
                "Taux de prime vol",
                "Valeur Declaree", "Taux de prime Incendie", "Franchise",
                "Capital Deces", "Capital Invalidite", "Capital Frais Medicaux", "Nombre de places", "Franchise", "Montant Indemnité"] ;

  selectedParam = "" ;

  baseElement = "" ;

  @Input() title : any  ;

  saveBtnState = "done_all" ;

  results = [] ;

  ngOnInit(){
    if (this.title=="Energie"){
        this.predefini = true ;
        this.predefinedSetOfElts = ["Essence", "Diesel", "Hybride", "Electrique"] ;
    }
    else
        this.predefini = false ;

    this.choicebi = "calculFormula" ;
  }
 
  pressNum(num: string) {

    if (num==".") {
	    if (this.input !="" ){
	        const lastNum=this.getLastOperand() ;
	        console.log(lastNum.lastIndexOf(".")) ;
	        if (lastNum.lastIndexOf(".") >= 0) 
            return;
	    }
    }
 
    if (num=="0") {
      if (this.input=="" ) {
        return;
      }
      const PrevKey = this.input[this.input.length - 1];
      if (PrevKey === '/' || PrevKey === '*' || PrevKey === '-' || PrevKey === '+')  {
          return;
      }
    }
    
    this.valToAdd =  this.valToAdd + num ;

    this.input = this.input + num ;
  }
  
  getLastOperand() {
    let pos:number;
    console.log(this.input)
    pos=this.input.toString().lastIndexOf("+") ;
    if (this.input.toString().lastIndexOf("-") > pos) 
      pos=this.input.lastIndexOf("-") ;
    if (this.input.toString().lastIndexOf("*") > pos) 
      pos=this.input.lastIndexOf("*") ;
    if (this.input.toString().lastIndexOf("/") > pos) 
      pos=this.input.lastIndexOf("/");
    console.log('Last '+this.input.substr(pos+1)) ;
    return this.input.substr(pos+1)
  }
 
  pressOperator(op: string) {
     
    if (this.valToAdd!=""){
      this.formulation.push(this.valToAdd);
      this.valToAdd = "" ;
    }

    this.formulation.push(op) ;

    const lastKey = this.input[this.input.length - 1];

    if (lastKey === '/' || lastKey === '*' || lastKey === '-' || lastKey === '+')  {
      return;
    }
    
    if(op=="min")
      op = " (minoré de) " ;
    if(op=="maj")
      op = " (majoré de) " ;
    if(op=="if")
      op = " Si " ;
    if(op=="supegal")
      op = " ≥ " ;
    if(op=="infegal")
      op = " ≤ " ;

    if(op=="supstrict")
      op = " > " ;
    if(op=="infstrict")
      op = " < " ;


    if(op=="set"){
      this.choicebi = "SetOfElts" ;
      op="" ;
    }

    if(op=="setRec"){
      this.choicebiIns = "RecParam" ;
      op="" ;
    }

    if(op!=""){
      if(op!="%")
        this.input = this.input + " " + op +" " ;
      else
        this.input = this.input + op ;      
    }
  }
 
  clear() {
    if (this.input !="" ) {
      this.input=this.input.substr(0, this.input.length-1) ;
      this.formulation.pop() ;
    }
  }
 
  allClear() {
    this.result = '';
    this.input = '';
    this.formulation = [] ;
    this.allformulas = [] ;
  }
 
  calcAnswer() {
    let formula = this.input;
 
    let lastKey = formula[formula.length - 1];
 
    if (lastKey === '.')  {
      formula=formula.substr(0,formula.length - 1);
    }
 
    lastKey = formula[formula.length - 1];
 
    if (lastKey === '/' || lastKey === '*' || lastKey === '-' || lastKey === '+' || lastKey === '.')  {
      formula=formula.substr(0,formula.length - 1);
    }
 
    console.log("Formula " +formula);
    this.result = eval(formula);
  }
 
  getAnswer() {

    if(this.input.length!=0)
      this.results.push(this.input) ;

    if(this.choicebiIns=='RecParam'){
       this.allParams= this.allParams.concat(this.setOfElts);
       this.choicebiIns = "" ;      
    }

    if (this.valToAdd!=""){
      this.formulation.push(this.valToAdd);
      this.valToAdd = "" ;
    }

    this.allformulas.push(this.formulation) ;

    this.formulation = [] ;

    console.log(this.allformulas) ;

    this.input = "";
  }

  closeEdit(index){
    
    this.results.splice(index, 1) ;
  }

  onParamChoosen(event){

    if (event.value!="") {
      this.input = this.input + "(" + event.value.replace(/\s+/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, "")+ ")" ;
      this.selectedParam = "" ;
      this.formulation.push( event.value.replace(/\s+/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, "") ) ;
    }
  }

  jsonElementFactory(baseElmt, newProp, intitule, type){
    if (baseElmt=="")
      return '{"paramprimName": "'+this.title+'", "params": [{'+'"name" : "'+newProp+'", "intitule": "'+intitule+'", "type": "'+type+'" }]}' ;  
    else
      return baseElmt.substring(0, baseElmt.length-2)+', {"name" : "'+newProp+'", "intitule": "'+intitule+'", "type": "'+type+'" }]}' ;
  }

  saveTypeConfig(){

    if(this.choicebi=='SetOfElts'){
      this.allformulas.push(this.formulation) ;
    }

    if (this.saveBtnState=="done_all"){
      var stringifiedFormulas = JSON.stringify(this.allformulas) ;
      console.log(stringifiedFormulas);
      this.FormulaToReturnBackEvent.emit(stringifiedFormulas) ;
      this.saveBtnState = "edit" ;  
    }else{
      this.saveBtnState = "done_all" ;      
    }
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      this.setOfElts.push(value.trim());
      this.formulation.push(value.trim()) ;
      console.log("The FOrmulation by now "+JSON.stringify(this.formulation)) ;
    }
    if (input) {
      input.value = '';
    }
  }

  remove(index): void {
    console.log("there we are with "+index) ;
    if (index >= 0) {
      this.setOfElts.splice(index, 1);
    }
  }

  addPredef(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    if (this.predefinedSetOfElts.includes(value) && !this.setOfElts.includes(value)) {
      this.setOfElts.push(value);
      this.formulation.push(value) ;
      console.log("The FOrmulation by now "+JSON.stringify(this.formulation)) ;
    }
    if (input) {
      input.value = '';
    }
    this.fruitCtrl.setValue(null);
  }

  selectedPredef(event: MatAutocompleteSelectedEvent): void {
    if(!this.setOfElts.includes(event.option.viewValue)){
      this.setOfElts.push(event.option.viewValue);
      this.formulation.push(event.option.viewValue) ;
      console.log("The FOrmulation by now "+JSON.stringify(this.formulation)) ;

      this.fruitInput.nativeElement.value = '';
      this.fruitCtrl.setValue(null);      
    }
  }

  removePredef(index): void {
    console.log("there we are with "+index) ;
    if (index >= 0) {
      this.setOfElts.splice(index, 1);
    }
  }

  changeTypeChoice(event){
    this.choosenType = event.value ;
    if(this.choosenType=="Choix multiple")
      this.choicebi='choixmultiple' ;
    if(this.choosenType=="Intervalle")
      this.choicebi='intervalle' ;
    if(this.choosenType=="Calculée")
      this.choicebi='calculee' ;
  }


}